// @ts-strict-ignore
import {Component, Injector, OnInit} from "@angular/core";
import {
	BasicMaterialDialog,
	MatDialogDataBaseInput,
	MatDialogDataBaseOutput,
} from "../../basic-material-dialog/basic-material-dialog.directive";
import {NotificationService, SimUtilityService} from "@services";
import {TranslateService} from "@ngx-translate/core";
import {Translations} from "@translations";

export interface DialogData_LocalizationExcelFileDialogInput extends MatDialogDataBaseInput {}

export interface DialogData_LocalizationExcelFileDialogOutput extends MatDialogDataBaseOutput {
	myExcelFile?: any;
}
@Component({
	selector: "sim-upload-localization-excel-file-dialog",
	templateUrl: "./upload-localization-excel-file-dialog.component.html",
	styleUrls: ["./upload-localization-excel-file-dialog.component.scss"],
	standalone: false,
})
export class UploadLocalizationExcelFileDialogComponent extends BasicMaterialDialog<
	UploadLocalizationExcelFileDialogComponent,
	DialogData_LocalizationExcelFileDialogInput,
	DialogData_LocalizationExcelFileDialogOutput
> {
	T = Translations;
	SimUtilityService = SimUtilityService;
	public myDialogTitle: string = "Upload Localization Excel File";
	excelLoaded: boolean = false;
	public excelFile: any;

	constructor(
		private _translate: TranslateService,
		_injector: Injector,
		private _simNotificationService: NotificationService,
	) {
		super(_injector);
	}
	ngOnInit(): void {}

	onFileSelected(event: any) {
		this.excelLoaded = false;
		const file: File = event.target.files[0];
		if (this.isExcelFile(file)) {
			this.excelFile = file;
			this.excelLoaded = true;
		}
	}

	isExcelFile(file: File): boolean {
		const allowedExtensions = [".xlsx", ".xls"];
		const fileExtension = file.name.split(".").pop();
		if (fileExtension && allowedExtensions.includes("." + fileExtension.toLowerCase())) {
			return true;
		}
	}

	uploadExcelFile() {
		const formData: FormData = new FormData();
		formData.append("excelFile", this.excelFile, this.excelFile.name);

		this.close({
			action: "ok",
			myExcelFile: this.excelFile,
		});
	}
}
